<span class="step-word">{{strings.step | tiStringFormat : currentStep}}</span>
<span class="step-circle" [class.filled]="currentStep === index + 1"
      *ngFor="let i of getStepsArray(); let index = index">
</span>
